import { Alert, Button } from "@onengine/component-library";
import styles from "./Assistant.module.scss";

interface ProposalBannerProps {
  isStale: boolean;
  isBusy: boolean;
  replacedQuestionCount: number;
  onDiscard: () => void;
  onApply: () => void;
}

export function ProposalBanner({
  isStale,
  isBusy,
  replacedQuestionCount,
  onDiscard,
  onApply,
}: ProposalBannerProps) {
  if (isStale) {
    return (
      <Alert
        title="This form changed after the proposal was made"
        message="Applying it now would overwrite those changes. Discard the proposal and ask again."
        type="warning"
        variant="plain"
        size="small"
        presentation="inline"
        actions={[{ label: "Discard proposal", onClick: onDiscard }]}
      />
    );
  }

  return (
    <div role="status" className={styles.banner}>
      <span className={styles.bannerText}>
        <strong>{"You are previewing the assistant's proposal."}</strong> It is not saved. Try it
        like a technician would, then apply it or keep chatting.
        {replacedQuestionCount > 0 &&
          ` Applying replaces the ${replacedQuestionCount} ${
            replacedQuestionCount === 1 ? "question" : "questions"
          } now in this form.`}
      </span>
      <div className={styles.cardActions}>
        <Button variant="secondary" size="small" onClick={onDiscard} isDisabled={isBusy}>
          Discard
        </Button>
        <Button variant="primary" size="small" onClick={onApply} isDisabled={isBusy}>
          Apply to form
        </Button>
      </div>
    </div>
  );
}
